export default __webpack_public_path__ + "static/media/coming-soon.753c9bd6.png";